async function refreshCartAndHeader() {
    const [cartRes, headerRes] = await Promise.all([
      fetch('/cart.js'),
      fetch('/?sections=header'),
    ]);
  
    const cartData = await cartRes.json();
    const headerHTML = await headerRes.json();
  
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'custom',
      cartData,
    });
  
    const header = document.getElementById('shopify-section-header');
    if (header && headerHTML.header) {
      header.innerHTML = headerHTML.header;
    }
}
  
async function adHocSubmitATCFormAndRefreshCart(form_selector, fn=null) {
    const form = document.querySelector(form_selector);
    const formData = new FormData(form);
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    refreshCartAndHeader();
    if(fn) {
      fn();
    }
}
  
  document.addEventListener('refresh:cart', () => {
    refreshCartAndHeader();
  });

async function addToCart(variantId, quantity = 1, fn = null) {
    if (!variantId) return;
  
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1
      })
    });
  
    await refreshCartAndHeader();
  
    if (fn) {
      fn();
    }
}

window.addEventListener('hashchange', () => {
    console.log('The hash has changed to:', window.location.hash);
    if(window.location.hash.indexOf('add:') > -1) {
        const variantId = window.location.hash.split('add:')[1]
        history.replaceState(null, document.title, window.location.pathname + window.location.search);
        addToCart(variantId,1,refreshCartAndHeader)
    }
  }, false);